<template>
  <router-link
    :to="link"
    class="go-back fz-link"
    v-if="link"
    data-comp="a-backlink"
  >
    <i-arrow-forward class="go-back__arrow" />
    <span class="go-back__text">{{ linkText }}</span>
  </router-link>
</template>

<script setup>
defineProps({
  link: {
    type: String,
    default: ""
  },
  linkText: {
    type: String,
    default: ""
  }
});
</script>

<style lang="scss" scoped>
.go-back {
  margin-bottom: pxToRem(30);
  display: inline-block;
  &__arrow {
    transform: rotate(180deg);
    margin-right: pxToRem(10);
  }
}
</style>
